import ShootingArrowList from './ShootingArrowList.vue';
import ShootingArrow from './ShootingArrow.vue';

export default {
  ShootingArrowList,
  ShootingArrow,
};
